import React, {Suspense} from 'react';
import {Routes, Route} from 'react-router-dom';
import Embed2 from '@src/Presentation/Embed2';

const Player = React.lazy(() => import('@src/Presentation/Player'));
const Iframe = React.lazy(() => import('@src/Presentation/IframeTest'));
const PlayLive = React.lazy(() => import('@src/Presentation/PlayLive'));
const Ebook = React.lazy(() => import('@src/Presentation/Ebook'));
const PrintEbook = React.lazy(() => import('@src/Presentation/PrintEbook'));
const PrintToDoList = React.lazy(() => import('@src/Presentation/PrintToDoList'));

export type Router2Props = {
  code?: string;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ code }: Router2Props) => {
  return (
    <Suspense fallback={<div>&nbsp;</div>}>
      <Routes>
        <Route path="/embed/:id" element={<Embed2 code={code || ''} />} />
        <Route path="/live/:id" element={<Embed2 code={code || ''} />} />
        <Route path="/page/live/:id" element={<PlayLive code={code || ''} />} />
        <Route path="/player" element={<Player />} />
        <Route path="/iframe-test" element={<Iframe />} />
        <Route path="/ebook/:id" element={<Ebook />} />
        <Route path="/print-ebook/:origin/:id" element={<PrintEbook />} />
        <Route path="/print-todolist/:origin/:id" element={<PrintToDoList />} />
        <Route path="/watch/:id" element={<Embed2 code={code || ''} />} />
      </Routes>
    </Suspense>
  );
};
